<template>
    <div style="z-index: -1; padding-bottom: 70px">

        <Wp_tb_my_child_num_income></Wp_tb_my_child_num_income>

        <div style="margin-bottom: 10px; padding: 0px 13px">
            <Wp_my_child_search @clickToSearch="clickToSearch" @clickToShowAll="clickToShowAll"></Wp_my_child_search>
        </div>

        <van-collapse v-model="activeNames">
            <van-collapse-item name="1" >
                <div slot="title" ><h2>下级代理</h2></div>

                <van-button slot="right-icon" plain round type="danger" size="mini" >{{collapse_righe_icon_two}}</van-button>
                <div>
<!--                    <div style="margin-bottom: 10px">-->
<!--                        <Wp_my_child_search @clickToSearch="two_clickToSearch" @clickToShowAll="two_clickToShowAll"></Wp_my_child_search>-->
<!--                    </div>-->
                    <i-table class="iview_table_child"
                             :rowClassName="rowClassName_two"
                             :loading="isLoading"
                             no-data-text="未搜索到数据" border :columns="two_column" :data="two_datas"
                    ></i-table>
                    <div style="text-align: right; margin-top: 5px">
                        <van-button plain round type="danger" size="mini" @click="two_hide">{{collapse_righe_icon_two}}</van-button>
                    </div>
                    <van-divider :style="{borderColor: '#999999', 'margin': '5px 0px 10px 0px'}"></van-divider>
                </div>

            </van-collapse-item>

            <van-collapse-item name="2">
                <div slot="title" ><h2>下下级代理</h2></div>

                <van-button slot="right-icon" plain round type="danger" size="mini" >{{collapse_righe_icon_three}}</van-button>

                <div>
<!--                    <div style="margin-bottom: 10px">-->
<!--                        <Wp_my_child_search @clickToSearch="three_clickToSearch" @clickToShowAll="three_clickToShowAll"></Wp_my_child_search>-->
<!--                    </div>-->
                    <i-table class="iview_table_child"
                             :rowClassName="rowClassName_three"
                             border no-data-text="未搜索到数据"
                             :columns="three_column"
                             :data="three_datas"
                    ></i-table>
                    <div style="text-align: right; margin-top: 5px">
                        <van-button plain round type="danger" size="mini" @click="three_hide">{{collapse_righe_icon_three}}</van-button>
                    </div>
                    <van-divider :style="{borderColor: '#999999', 'margin': '5px 0px 10px 0px'}"></van-divider>
                </div>

            </van-collapse-item>
        </van-collapse>

    </div>
</template>

<script>

    import Vue from 'vue';
    import {Table, Alert} from 'iview';
    import Wp_tb_my_child_num_income from "./Wp_tb_my_child_num_income";
    import Wp_my_child_search from "../../custom/Wp_my_child_search";

    Vue.component("i-table", Table);
    Vue.component("Alert", Alert);

    export default {
        name: "Wp_tb_my_child_member",
        components: {Wp_my_child_search, Wp_tb_my_child_num_income},
        data() {
            return {

                isLoading: true,

                activeNames: ['1'],
                // right_button_two:{
                //     text: "收起",
                //     icon: "arrow-up"
                // },
                //
                // right_button_three:{
                //     text: "展开",
                //     icon: "arrow-down"
                // },

                collapse_righe_icon_two: "收起",
                collapse_righe_icon_three: "展开",


                two_length: 0,

                three_length: 0,

                two_column: [
                    {
                        title: '代理名称',
                        key: 'two_name',
                        width: 90,
                    },
                    {
                        title: '今日预估分成',
                        key: 'two_yesterday',

                    },
                    {
                        title: '当月预估分成',
                        key: 'two_month',

                    }
                ],
                two_datas: [],
                two_datas_summary: [],
                three_column: [
                    {
                        title: '代理名称',
                        key: 'three_name',
                        width: 90,
                    },
                    {
                        title: '今日预估分成',
                        key: 'three_yesterday'
                    },
                    {
                        title: '当月预估分成',
                        key: 'three_month'
                    }
                ],
                three_datas: [],

                // column:[
                //     {
                //         title: '下级代理',
                //         key: 'two',
                //         align: 'center'
                //     },
                //     {
                //         title: '下下级代理',
                //         key: 'three',
                //         align: 'center'
                //     }
                // ],
                // datas: [],

                twoDatas: [],
                threeDatas: [],

                two_childname: "",
                three_childname: "",

                child_type: "",
            }
        },

        mounted() {
            // this.getUserLevel();

            this.getPidLevelCountList();

        },
        methods: {

            two_hide(){
                for(let i = 0; i < this.activeNames.length; i++){
                    if(this.activeNames[i] === "1"){
                        this.activeNames.splice(i,1)
                        return;
                    }
                }
            },

            two_show(){
                this.activeNames = [];
                this.activeNames.push("1")
            },

            three_hide(){
                for(let i = 0; i < this.activeNames.length; i++){
                    if(this.activeNames[i] === "2"){
                        this.activeNames.splice(i,1)
                        return;
                    }
                }
            },

            three_show(){
                this.activeNames = [];
                this.activeNames.push("2")
            },


            clickToSearch(child_name){
                if(this.two_clickToSearch(child_name)){
                    this.two_show();
                    setTimeout(()=>{
                        this.three_clickToShowAll();
                    }, 100);

                }else if(this.three_clickToSearch(child_name)){
                    this.three_show();
                    setTimeout(()=>{
                        this.two_clickToShowAll();
                    }, 100);

                }else{
                    this.activeNames = ["1", "2"];
                    this.$dialog.alert({
                        message: "没有找到 " + child_name + " 的相关数据"
                    });
                }
            },

            clickToShowAll(){
                this.two_show();
                this.three_hide();
                this.two_clickToShowAll();
                this.three_clickToShowAll();
                // if(this.child_type === "two"){
                //     this.two_clickToShowAll();
                // }else if(this.child_type === "three"){
                //     this.three_clickToShowAll();
                // }else{
                //
                // }
            },

            two_clickToSearch(child_name){
                if(this.twoDatas && this.twoDatas.length > 0){
                    this.two_datas = [];
                    for(let i = 0; i < this.twoDatas.length; i++){
                        if(this.twoDatas[i].u_mark.toLowerCase() === child_name){
                            this.two_datas.push({
                                two_name: this.twoDatas[i].u_mark,
                                two_yesterday: Number(this.twoDatas[i].yestimateFees).toFixed(2) + " 元",
                                two_month: Number(this.twoDatas[i].mestimateFees).toFixed(2) + " 元",
                            });

                            return true;
                        }
                    }
                    // if(this.two_datas.length === 0){
                    //     this.$dialog.alert({
                    //         message: "没有找到 " + child_name + " 的相关数据"
                    //     });
                    //     this.two_clickToShowAll();
                    //     return false;
                    // }
                }
                return false;
            },

            two_clickToShowAll(){
                if(this.twoDatas){
                    this.initTwoDatas(this.twoDatas);
                }
            },

            three_clickToSearch(child_name){
                if(this.threeDatas && this.threeDatas.length > 0){
                    this.three_datas = [];
                    for(let i = 0; i < this.threeDatas.length; i++){
                        if(this.threeDatas[i].u_mark.toLowerCase() === child_name){
                            this.three_datas.push({
                                three_name: this.threeDatas[i].u_mark,
                                three_yesterday: Number(this.threeDatas[i].yestimateFees).toFixed(2) + " 元",
                                three_month: Number(this.threeDatas[i].mestimateFees).toFixed(2) + " 元",
                            });

                            return true;
                        }
                    }
                    // if(this.three_datas.length === 0){
                    //     this.$dialog.alert({
                    //         message: "没有找到" + child_name + "的相关数据"
                    //     });
                    //     this.three_clickToShowAll();
                    //     return false;
                    // }
                }
                return false;
            },

            three_clickToShowAll(){
                if(this.threeDatas){
                    this.initThreeDatas(this.threeDatas);
                }
            },

            rowClassName_two(row,index){

                if(this.two_datas && index === this.two_datas.length -1){
                    // this.$log("this.two_datas.length -1 = " + (this.two_datas.length -1))
                    return "table-last-row";
                }
                return "";
            },

            rowClassName_three(row,index){

                if(this.three_datas && index === this.three_datas.length -1){
                    // this.$log("this.two_datas.length -1 = " + (this.three_datas.length -1))
                    return "table-last-row";
                }
                return "";
            },

            getPidLevelCountList(){
                let params = {
                    u_mark: this.$store.state.username,
                };

                this.$getPidLevelCountList_tb(params, response =>{
                    this.$log(response)
                    if(response.code === 200){
                        this.isLoading = false;
                        this.initTableDatas(response);
                    }else if(response.toString().indexOf("Error: timeout") != -1){
                        this.$dialog.confirm({
                            message: "数据加载超时，请重试"
                        }).then(()=>{
                            this.getPidLevelCountList();
                        }).catch(()=>{
                            this.isLoading = false;
                        });
                    }

                });
            },

            /**
             * 初始化表格数据
             */
            initTableDatas(data){
                this.twoDatas = data.twodata;
                this.threeDatas = data.threedata;

                this.initTwoDatas(this.twoDatas);

                this.initThreeDatas(this.threeDatas);
            },

            initTwoDatas(twoDatas){
                if(twoDatas && twoDatas.length > 0){
                    this.two_datas = [];
                    let yesterday_sum = 0;
                    let month_sum = 0;
                    for(let i = 0; i < twoDatas.length; i++){
                        this.two_datas.push({
                            two_name: twoDatas[i].u_mark,
                            two_yesterday: Number(twoDatas[i].yestimateFees).toFixed(2) + " 元",
                            two_month: Number(twoDatas[i].mestimateFees).toFixed(2) + " 元",
                        });
                        yesterday_sum += Number(Number(twoDatas[i].yestimateFees).toFixed(2));
                        month_sum += Number(Number(twoDatas[i].mestimateFees).toFixed(2));
                    }

                    this.two_datas.push({
                        two_name: twoDatas.length + " 个",
                        two_yesterday: yesterday_sum.toFixed(2) + " 元",
                        two_month: month_sum.toFixed(2) + " 元",
                    });

                }
            },

            initThreeDatas(threeDatas){
                if(threeDatas && threeDatas.length > 0){
                    this.three_datas = [];
                    let yesterday_sum = 0;
                    let month_sum = 0;

                    for(let i = 0; i < threeDatas.length; i++){
                        this.three_datas.push({
                            three_name: threeDatas[i].u_mark,
                            three_yesterday: Number(threeDatas[i].yestimateFees).toFixed(2) + " 元",
                            three_month: Number(threeDatas[i].mestimateFees).toFixed(2) + " 元",
                        });
                        yesterday_sum += Number(Number(threeDatas[i].yestimateFees).toFixed(2));
                        month_sum += Number(Number(threeDatas[i].mestimateFees).toFixed(2));
                    }

                    this.three_datas.push({
                        three_name: threeDatas.length + " 个",
                        three_yesterday: yesterday_sum.toFixed(2) + " 元",
                        three_month: month_sum.toFixed(2) + " 元",
                    })
                }
            }
        },

        watch:{
            activeNames(value) {
                if (value && value.length > 0) {

                    this.$log(value)

                    if(value.includes("1")){
                        this.collapse_righe_icon_two = '收起';
                    }else{
                        this.collapse_righe_icon_two = '展开';
                    }

                    if(value.includes("2")){
                        this.collapse_righe_icon_three = '收起';
                    }else{
                        this.collapse_righe_icon_three = '展开';
                    }

                } else {
                    this.collapse_righe_icon_two = '展开';
                    this.collapse_righe_icon_three = '展开';
                }
            }
        }
    }
</script>

<style>
    /*.ivu-table-header th{*/
    /*    color:#000;*/
    /*    font-weight: bold;*/
    /*    background-color: #cbf7ff;*/
    /*    !*border: none;*!*/
    /*}*/
    /*.ivu-table td{*/
    /*    background-color: #d6fffa;*/
    /*    color: #000;*/
    /*    !*border-color: red;*!*/
    /*}*/
    .ivu-table .table-last-row td{
        /*background-color: #D70C12;*/
        font-size: 18px;
        color: #FF0000;
        font-weight: bold;
        border-top: 1px solid #909090;
    }

    .iview_table_child .ivu-table-header tr {
         /*box-shadow: inset 0px 0px 12px 1px #232e3c;*/
         background-color: #219EFF;
         color: white;
     }
    .iview_table_child .ivu-table-border td, .iview_table_child .ivu-table-border th {
        /*border-color: #1978e2;*/
        background: none;
        /*color: inherit;*/
        /*font-size: 13px;*/
    }
</style>